import { Home, Liquor, ShoppingBag, Store, Task } from '@mui/icons-material'
import { PlanType } from 'graphql/generated-types'

import { SidebarItemsType } from '@/types/sidebar'

const navItems = (
  t: (key: string) => string,
  hasMultipleStores?: boolean,
  userPlan?: PlanType,
): {
  title: string
  pages: SidebarItemsType[]
}[] => {
  const isBasicPlan = userPlan === PlanType.BASIC

  const reportSection: SidebarItemsType[] = hasMultipleStores
    ? [
        {
          href: '/home',
          icon: Home,
          title: t('dashboardItems.reporting.home'),
          id: 'home-nav',
        },
        {
          href: '/stores',
          icon: Store,
          title: t('dashboardItems.reporting.stores'),
          id: 'stores-nav',
        },
        {
          href: '/products',
          icon: ShoppingBag,
          title: t('dashboardItems.admin.products'),
          id: 'products-nav',
          badge: isBasicPlan ? t('dashboardItems.badge.premium') : undefined,
        },
        {
          href: '/tasks',
          icon: Task,
          title: t('dashboardItems.admin.tasks'),
          id: 'tasks-nav',
        },
        {
          href: '/restocks',
          icon: Liquor,
          title: t('dashboardItems.admin.restocks'),
          id: 'restocks-nav',
        },
      ]
    : [
        {
          href: '/home',
          icon: Home,
          title: t('dashboardItems.reporting.home'),
          id: 'home-nav',
        },
        {
          href: '/products',
          icon: ShoppingBag,
          title: t('dashboardItems.admin.products'),
          id: 'products-nav',
          badge: isBasicPlan ? t('dashboardItems.badge.premium') : undefined,
        },
      ]
  return [
    {
      title: '',
      pages: reportSection,
    },
  ]
}

export default navItems
